// geo
import { City } from './geo/City';
import { Counties } from './geo/Counties';
import { DMA } from './geo/DMA';
import { Geofence } from './geo/Geofence';
import { Country } from './geo/Country';
import { Radius } from './geo/Radius';
import { Residency } from './geo/Residency';
import { State } from './geo/State';
import { ZipCodes } from './geo/ZipCodes';

// audience
import { BehavioralInterest } from './audience/BehavioralInterest';
import { CustomXandrSegments } from './audience/CustomXandrSegments';
import { BehavioralSegments } from './audience/BehavioralSegments';
import { SequencialTargeting } from './audience/SequencialTargeting';

import { Demographic } from './audience/Demographic';
import { FirstPartyData } from './audience/FirstPartyData';
import { SearchRetargeting } from './audience/SearchRetargeting';
import { AudienceNotes } from './audience/AudienceNotes';

// publisher
import { AudioSpecificIndustryVerticals } from './publisher/AudioSpecificIndustryVerticals';
import { Blocklist } from './publisher/Blocklist';
import { ContentChannel } from './publisher/ContentChannel';
import { ContentVertical } from './publisher/ContentVertical';
import { KeywordContextual } from './publisher/KeywordContextual';
import { LiveEvents } from './publisher/LiveEvents';
import { PMP } from './publisher/PMP';
import { RunOfNetwork } from './publisher/RunOfNetwork';
import { SpecificPublisher } from './publisher/SpecificPublisher';
import { Allowlist } from './publisher/Allowlist';
import { PremiumContent } from './publisher/PremiumContent';
import { PremiumCTV } from './publisher/PremiumCTV';
import { PremiumOTT } from './publisher/PremiumOTT';
import { CTVRON } from './publisher/CTV-RON';
import { PublisherNotes } from './publisher/PublisherNotes';
import { FlipOTT } from './publisher/FlipOTT';
import { ContextualTargeting } from './publisher/ContextualTargeting';

const TargetingTypes = {
  // Geo
  City,
  Counties,
  DMA,
  Geofence,
  Country,
  Radius,
  Residency,
  State,
  ZipCodes,

  // Audience
  BehavioralInterest,
  BehavioralSegments,
  SequencialTargeting,
  Demographic,
  FirstPartyData,
  SearchRetargeting,
  AudienceNotes,
  CustomXandrSegments,

  // Publisher / Inventory Quality
  AudioSpecificIndustryVerticals,
  Blocklist,
  ContentChannel,
  ContentVertical,
  CTVRON,
  KeywordContextual,
  LiveEvents,
  PMP,
  PremiumContent,
  PremiumCTV,
  PremiumOTT,
  RunOfNetwork,
  SpecificPublisher,
  Allowlist,
  PublisherNotes,
  FlipOTT,
  ContextualTargeting,
};

// eslint-disable-next-line import/prefer-default-export
export { TargetingTypes };
